import { PropsWithChildren } from 'react';
import { Box, BoxProps, Flex } from 'reflexbox';
import styled from 'styled-components';
import { rgba } from 'polished';

import { Link } from '@treams/treams-routes';

export const Segment = styled(Box)<{ selected?: boolean }>`
	border: 1px solid ${(props) => rgba(props.theme.colors.primary, 0.25)};
	padding: 5px 10px;
	border-right-width: 0px;
	color: ${(props) => (props.selected ? 'white' : props.theme.colors.primary)};
	text-align: center;

	${(props) =>
		props.selected
			? `
		background: ${props.theme.colors.primary};
		padding-right: 11px;
		margin-right: -1px;
	`
			: `
		cursor: pointer;

		&:hover {
			background: ${rgba(props.theme.colors.primary, 0.1)};

			&:active {
				background: ${rgba(props.theme.colors.primary, 0.25)};
			}
		}
	`}
`;

export function SegmentLink(
	props: PropsWithChildren<BoxProps & { selected?: boolean; to: string }>,
) {
	const { selected, to, ...rest } = props;

	return (
		<Box {...(rest as any)}>
			<Link to={to}>
				<Segment selected={selected}>{props.children}</Segment>
			</Link>
		</Box>
	);
}

const SegmentBar = styled(Flex)`
	> :first-child ${Segment}, > ${Segment}:first-child {
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
	}

	> :last-child ${Segment}, > ${Segment}:last-child {
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
		border-right-width: 1px;
	}
`;

export default SegmentBar;
